export default __webpack_public_path__ + "static/media/collection-image.09a8b1df.png";